<div class="header-row">
   <button class="white-button" (click)="openFavorites()">
      View Favorites<span class="material-icons-outlined">bookmarks</span>
   </button>
   <!-- <button class="white-button">
      Compare Blend<span class="material-icons-outlined">table_chart</span>
   </button> -->
   <button class="white-button" (click)="exportPrediction()" [disabled]="!(hasPredictions$ | async)">
      Export Prediction<span class="material-icons-outlined">download</span>
   </button>
   <button class="white-button" (click)="clearBlend1()">
      Clear Blend 1<span class="material-icons-outlined">delete_forever</span>
   </button>
   <button class="white-button" (click)="clearBlend2()">
      Clear Blend 2<span class="material-icons-outlined">delete_forever</span>
   </button>
</div>
<div class="main-container">
   <div class="content">
      <div class="left-side" [style.width.px]="leftSideWidth">
         <div class="left-side-content">
            <app-bc-finished-oil-blend></app-bc-finished-oil-blend>
         </div>
      </div>
      <div class="divider resizable" role="separator" aria-label="Divider" (mousedown)="onMouseDown()"></div>
      <div class="right-side" [style.width.px]="rightSideWidth">
         <app-bc-prediction-results></app-bc-prediction-results>
      </div>
   </div> 
</div>

<!-- Favorites Modal -->
<app-favorite-manager
   *ngIf="showFavorites"
   (closed)="closeFavorites()">
</app-favorite-manager>